/* PYNRS: sound on/off for an autoplaying uploaded video (video section option).
   The video keeps autoplaying muted; the tap unmutes inside the gesture so phones allow it,
   and starts playback if the browser had blocked autoplay. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sound-toggle]');
    if (!button) return;
    var media = document.getElementById(button.getAttribute('aria-controls'));
    var video = media && media.querySelector('video');
    if (!video) return;
    var soundOn = button.getAttribute('aria-pressed') !== 'true';
    if (soundOn) media.setAttribute('unmuted', ''); else media.removeAttribute('unmuted');
    video.muted = !soundOn;
    if (soundOn) {
      video.volume = 1;
      if (video.paused) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    }
    button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
    button.setAttribute('aria-label', soundOn ? button.getAttribute('data-label-off') : button.getAttribute('data-label-on'));
  });
})();
